module.exports = __webpack_public_path__ + "static/media/music.bdf4f278.svg";